<div *ngIf="!bookingService.isBookingReady && !serverErrorMessage">
  <app-loading-spinner></app-loading-spinner>
</div>
<p *ngIf="serverErrorMessage">
  {{serverErrorMessage}}
</p>
<app-email-sending-spinner *ngIf="bookingEmailService.emailSending"></app-email-sending-spinner>
<app-global-notification [message]="lastOpenedMessage"></app-global-notification>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
<p-dialog header="Add to mailing list" [(visible)]="displayBrevoDialog" [modal]="true">
  <div>
    <p class="global-warning">
      {{brevoContactErrorMessage}}
    </p>
  </div>
  <div *ngIf="isConnectingToBrevoServer || isUpdatingBrevoContact">
    <p-progressSpinner></p-progressSpinner>
    <p>Connecting to Brevo Server...</p>
  </div>
  <div class="brevo-lists-container" *ngIf="!isUpdatingBrevoContact && !isConnectingToBrevoServer">
    <div>
      <p-listbox [options]="brevoLists" [disabled]="listBoxDisabled" optionLabel="name"
        (onClick)="selectBrevoList($event.option)"></p-listbox>
    </div>
    <div class="selected-lists-container">
      <div *ngFor="let list of targetBrevoLists" (click)="removeBrevoList(list)" class="brevo-list-item">
        {{list.name}}</div>
    </div>
  </div>
</p-dialog>
<!-- When 'Add attachment files' button is clicked inside 'Send e-mail' -->
<p-dialog *ngIf="bookingEmailService.displayMailingDialog" [header]="bookingEmailService.emailDialogHeader"
  [(visible)]="bookingEmailService.displayMailingDialog" [modal]="true">
  <app-booking-email [isEmailToStudent]="bookingEmailService.isEmailToStudent"></app-booking-email>
</p-dialog>
<p-dialog [modal]="true" [(visible)]="bookingService.displayMailHistoryDetail"
  header="Details of email sent #{{bookingService.selectedEmailHistory.id}}"
  *ngIf="bookingService.selectedEmailHistory">
  <div class="email-history-container">
    <div class="email-line-item">
      <span class="email-item">Mail sent by </span>
      <span><strong>{{bookingService.selectedEmailHistory.email.sentBy.name}}</strong></span>
      <span class="email-item"> on </span>
      <span>
        <strong>
          {{bookingService.selectedEmailHistory.email.sentDateTime?.toDate() | date:'dd/MM/yyyy - HH:mm'}}
        </strong>
      </span>
    </div>
    <div class="email-line-item">
      <span class="email-item">
        Subject:
      </span>
      <span>
        <strong>
          {{bookingService.selectedEmailHistory.email.subject}}
        </strong>
      </span>
    </div>
    <div class="email-line-item">
      <span class="email-item">
        Sent to:
      </span>
      <span *ngFor="let recipient of bookingService.selectedEmailHistory.recipients">
        <strong>
          {{recipient}}
        </strong>
      </span>
    </div>
    <div class="email-message-section-container">
      <p class="email-item">
        Message:
      </p>
      <div [innerHTML]="bookingService.selectedEmailHistory.email.body" class="sent-email-message-container"></div>
    </div>
  </div>
</p-dialog>
<p-tabMenu [model]="bookingViewModeService.navigationItems" [activeItem]="bookingViewModeService.activeItem">
</p-tabMenu>
<div *ngIf="bookingService.isBookingReady" class="main-wrap">
  <div class="booking-wrap">
    <div>
      <div class="edit-zone">
        <div
          *ngIf="bookingViewModeService.selectedView == bookingViewModeService.BOOKING_VIEW && bookingService.bookingForm">
          <app-booking-summary></app-booking-summary>
        </div>
        <div *ngIf="bookingViewModeService.selectedView == bookingViewModeService.STUDENT_ZONE_VIEW">
          <app-booking-student-zone></app-booking-student-zone>
        </div>
        <div *ngIf="bookingViewModeService.selectedView == bookingViewModeService.STUDENT_VIEW">
          <app-booking-student></app-booking-student>
        </div>
        <div *ngIf="bookingViewModeService.selectedView == bookingViewModeService.ACCOMMODATION_VIEW">
          <app-booking-accommodation #accommodationComponent></app-booking-accommodation>
        </div>
        <div *ngIf="bookingViewModeService.selectedView == bookingViewModeService.PRE_CONFIRMATION_VIEW">
          <app-booking-pre-confirmation #preConfirmationComponent></app-booking-pre-confirmation>
        </div>
        <div *ngIf="bookingViewModeService.selectedView == bookingViewModeService.FILES_VIEW">
          <app-booking-files></app-booking-files>
        </div>
        <div *ngIf="bookingViewModeService.selectedView == bookingViewModeService.PAYMENTS_VIEW">
          <app-booking-transactions #transactionsComponent></app-booking-transactions>
        </div>
        <div *ngIf="bookingViewModeService.selectedView == bookingViewModeService.BRUGES_VIEW">
          <app-edit-booking-bruges-vnd></app-edit-booking-bruges-vnd>
        </div>
        <div *ngIf="bookingViewModeService.selectedView == bookingViewModeService.IMMERSION_VIEW">
          <app-edit-booking-immersion #editBookingImmersionComponent></app-edit-booking-immersion>
        </div>
        <div *ngIf="bookingViewModeService.selectedView == bookingViewModeService.HIGH_SCHOOL_VIEW">
          <app-edit-booking-high-school #editBookingHighSchoolComponent></app-edit-booking-high-school>
        </div>
      </div>
    </div>
    <div class="metadata-main-container">
      <div class="action-buttons" *ngIf="userService.hasAnyRole(['admin', 'editor', 'booking_viewer'])">
        <p class="metadata-title">
          Actions
        </p>
        <div class="action-buttons-container">
          <p-button (onClick)="updateBooking()" styleClass="p-button-success" label="Submit"
            [disabled]="bookingService.sendingUpdateRequest" [style]="{'width':'224px'}"></p-button>
          <p-button styleClass="p-button-warning" *ngIf="bookingService.booking.isActive"
            (onClick)="deactivateBooking()" label="Mark inactive" [style]="{'width':'224px'}"></p-button>
          <p-button *ngIf="!bookingService.booking.isActive" (onClick)="activateBooking()" label="Mark active"
            [style]="{'width':'224px'}"></p-button>
          <p-button label="Booking overview" (onClick)="printBookingRequest()" [style]="{'width':'224px'}"></p-button>
          <p-button *ngIf="bookingService.isBrugesVndBooking" icon="pi pi-file-excel" label="Add to SpreadSheet"
            (onClick)="addBookingToSpreadSheet()" [style]="{'width':'224px'}"
            [disabled]="addingToSpreadSheet"></p-button>
          <p-button *ngIf="userService.hasRole('booking_deleter')" label="Delete booking" (onClick)="deleteBooking()"
            styleClass="p-button-danger" icon="pi pi-trash" [style]="{'width':'224px'}">
          </p-button>
        </div>
        <div *ngIf="bookingViewModeService.selectedView == bookingViewModeService.PRE_CONFIRMATION_VIEW">
          <p class="metadata-title">
            Pré-Confirmation
          </p>
          <div class="action-buttons-container">
            <p-button label="Create Confirmation" (onClick)="activatePreConfirmationForm()"
              [style]="{'width':'224px'}"></p-button>
            <p-button label="Save as template" [style]="{'width':'224px'}"
              (onClick)="activateQuotationTemplateSavingDialog()"></p-button>
            <p-button label="Load templates" [style]="{'width':'224px'}" (onClick)="getQuotationTemplates()"></p-button>
          </div>
        </div>
        <p class="metadata-title">
          Contact
        </p>
        <div class="action-buttons-container">
          <p-button label="Email customer" [style]="{'width':'224px'}"
            (onClick)="bookingEmailService.activateGeneralEmailDialog(true)"
            [disabled]="!bookingService.booking.student.email"></p-button>
          <p-button label="Email school" [style]="{'width':'224px'}"
            (onClick)="bookingEmailService.activateGeneralEmailDialog(false)"
            [disabled]="!bookingService.booking.school"></p-button>
          <p-button label="Open in Zoiper" (onClick)="callPhoneNumber()" [style]="{'width':'224px'}"></p-button>
          <p-button (onClick)="activateBrevoDialog()" label="Brevo list" [style]="{'width':'224px'}">
          </p-button>
        </div>
        <p class="metadata-title">
          Links
        </p>
        <div class="action-buttons-container">
          <a *ngFor="let info of bookingService.programmeInformations" [href]="info.lviSiteUrl" target="_blank">
            <p-button label="LV Webpage {{info.label}}" [style]="{'width':'224px'}"></p-button>
          </a>
          <a *ngIf="bookingService.booking.school && bookingService.booking.school.siteUrl"
            [href]="bookingService.booking.school.siteUrl" target="_blank">
            <p-button label="Partner Webpage" [style]="{'width':'224px'}"></p-button>
          </a>
          <a *ngIf="bookingService.booking.school"
            routerLink="/management/edit-school/{{bookingService.booking.school.id}}" target="_blank">
            <p-button label="Partner File" [style]="{'width':'224px'}"></p-button>
          </a>
          <a *ngIf="bookingService.googleSheetPriceUrl" [href]="bookingService.googleSheetPriceUrl" target="_blank">
            <p-button icon="pi pi-dollar" label="Fees" [style]="{'width':'224px'}"></p-button>
          </a>
        </div>
      </div>
      <div class="metadata-container">
        <p class="metadata-title">
          Metadata
        </p>
        <p *ngIf="!bookingService.booking.lvmsId">
          Booking ID: {{bookingService.booking.id}}
        </p>
        <p *ngIf="bookingService.booking.lvmsId">
          Booking ID: {{bookingService.booking.lvmsId}}
        </p>
        <p>Creation date: {{bookingService.booking.created!.toDate() | date:'dd/MM/yyyy'}}</p>
        <p>Created by: {{bookingService.booking.createdBy!.name}}</p>
        <div class="agent-dropdown-container">
          <span>Agent:</span>
          <span
            *ngIf="userService.isNotAnyOf(['superadmin', 'sales_agent_manager'])">&nbsp;{{bookingService.booking.salesAgent.name}}</span>
          <span *ngIf="userService.hasAnyRole(['superadmin', 'sales_agent_manager'])">
            <p-dropdown [(ngModel)]="bookingService.booking.salesAgent" [style]="{'min-width':'80px'}"
              [options]="agents" optionLabel="name" (onChange)="updateSalesAgent()"></p-dropdown>
          </span>
        </div>
      </div>
      <div class="student-info-container">
        <p class="metadata-title">
          Student
        </p>
        <p>Family name: {{bookingService.booking.student.lastName}}</p>
        <p>First name: {{bookingService.booking.student.firstName}}</p>
        <p>Gender: <span *ngIf="bookingService.booking.student.gender">{{bookingService.booking.student.gender.name |
            titlecase}}</span></p>
        <p>Date of birth: <span *ngIf="bookingService.booking.student.birthDay">
            {{bookingService.booking.student.birthDay!.toDate() | date: 'dd/MM/yyyy'}}</span></p>
        <p>Language: <span
            *ngIf="bookingService.booking.student.language">{{bookingService.booking.student.language.name}}</span> </p>
        <p>Nationality: <span
            *ngIf="bookingService.booking.student.nationality">{{bookingService.booking.student.nationality.name}}</span>
        </p>
        <!-- Contact Information of Student -->
        <p class="metadata-title">Contact</p>
        <p>Mobile: {{bookingService.booking.student.mobileNumber}}</p>
        <p>Email: {{bookingService.booking.student.email}}</p>
        <p>Address: {{bookingService.booking.student.address}}</p>
        <p>City: {{bookingService.booking.student.city}}</p>
        <p>Country: {{bookingService.booking.student.country?.name}}</p>
      </div>
      <div [formGroup]="userAssignForm" class="counsellors-container" *ngIf="userAssignForm">
        <h3 class="global-title">
          Assign to
        </h3>
        <table>
          <tr>
            <th></th>
            <th></th>
          </tr>
          <tr formArrayName="usersInCharge" *ngFor="let user of usersFormArray; let i = index">
            <td>
              <p-checkbox [formControlName]="i" [binary]="true" (onChange)="updateUsersInCharge()">
              </p-checkbox>
            </td>
            <td>
              <p class="counsellor-name">
                {{counsellors[i].name | titlecase}}
              </p>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</div>